import React, { useMemo, useState } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useSaidasSuprimentos } from "./servicosData";
import { generatePdfReport } from "../../../utils/pdf/generatePdfReport";

const SuprimentosSaidas: React.FC = () => {
  const headers = [
    "OS",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Técnico",
    "C. Responsável",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useSaidasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "70px", // Código
    "300px", // Nome do Produto
    "50px", // Quantidade
    "90px", // Custo Unitário
    "90px", // Técnico
    "140px", // C. Responsável
    "90px", // Data
    "60px", // Hora
  ];

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const enabledColumnIndexes = useMemo(
    () =>
      selectedColumns
        .map((checked, i) => (checked ? i : -1))
        .filter((i) => i !== -1),
    [selectedColumns]
  );

  const footerLines = useMemo(() => {
    let totalQuantidade = 0;

    rows.forEach((row) => {
      const qtd = Number(String(row[3] ?? "").replace(",", "."));
      if (isFinite(qtd)) totalQuantidade += qtd;
    });

    return [`Total de Itens Baixados: ${totalQuantidade}`];
  }, [rows]);

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Baixas Serviços"
        buttons={[
          {
            label: "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Baixas para Serviço",
                fileNamePrefix: "Suprimentos-Baixas-Servicos",
                subtitle:
                  "Informações das Saídas Finalizadas de Material para Serviço",
                headers,
                rows,
                custoColIndex: 4,
                enabledColumns: enabledColumnIndexes,
                footerLines,
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              const updated = [...selectedColumns];
              updated[index] = checked;
              setSelectedColumns(updated);
            },
          },
        ]}
      />

      {loading ? (
        <div style={{ padding: 16 }}>Carregando saídas…</div>
      ) : (
        <Table
          headers={headers}
          rows={rows}
          columnWidths={columnWidths}
          isTableStandby
        />
      )}
    </div>
  );
};

export default SuprimentosSaidas;
